import axios from "axios";
import ParameterCompany from "../model/user-management/parameter-company.model";

const baseApiUrl = "api/parameters";

export default class ParameterService {
  public getAllParametersActivated(managerOrId?): Promise<ParameterCompany[]> {
    let url = window.location.href;
    let partOfUrl = url.split("/");
    if (!managerOrId) {
      managerOrId = partOfUrl.length > 5 ? partOfUrl[5] : "";
    }
    managerOrId = managerOrId.replace(/\?msg=\d+$/, "");
    if (url.includes("private")) {
      if (url.includes("360") || url.includes("esg"))
        return axios
          .get(baseApiUrl + "/activated/?reportId=" + managerOrId)
          .then((res) => res.data)
          .catch((error) => Promise.reject(error));
      else
        return axios
          .get(baseApiUrl + "/activated/?modulableId=" + managerOrId)
          .then((res) => res.data)
          .catch((error) => Promise.reject(error));
    } else {
      return axios
        .get(baseApiUrl + "/activated/?manager=" + managerOrId)
        .then((res) => res.data)
        .catch((error) => Promise.reject(error));
    }
  }
}
